const defaultState = {
  apiToken: null,
  user: {},
  parkingSession: null,
  vehicles: [],
  error: null,
  notificationCount: 0,
  paymentMethod: false,
  tncChange: false,
  // EV Charging management feature flag, fetched from GET /config/features
  // on boot. Defaults off so EV UI stays hidden until the backend confirms
  // it's enabled (and stays hidden if that fetch fails).
  evChargingEnabled: false,
};

export default defaultState;
